/**
 * Where an induction notification opens. Shared by the bell and push taps so
 * the two cannot disagree. Null for anything that is not an induction type.
 */
export function inductionNotificationPath(type: string | undefined, data?: Record<string, string | undefined>): string | null {
  if (!type || !type.startsWith('induction_')) return null;
  switch (type) {
    case 'induction_request':
      return '/inductions?tab=requests';
    case 'induction_approved':
    case 'induction_declined':
      return data?.job_id ? `/jobs/${data.job_id}` : '/my-inductions';
    case 'induction_updated':
      return data?.induction_id ? `/my-inductions/equipment/${data.induction_id}` : '/my-inductions';
    case 'induction_pack_due':
      return data?.doc_id ? `/my-inductions/policies/${data.doc_id}` : '/my-inductions';
    default:
      // induction_expiring / induction_expired and anything newer
      return '/my-inductions';
  }
}
